import { render, staticRenderFns } from "./InventoryFilter.vue?vue&type=template&id=e4b1e6ba&scoped=true&"
import script from "./InventoryFilter.vue?vue&type=script&lang=js&"
export * from "./InventoryFilter.vue?vue&type=script&lang=js&"
import style0 from "./InventoryFilter.vue?vue&type=style&index=0&id=e4b1e6ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4b1e6ba",
  null
  
)

export default component.exports